"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlatDesktop = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var styles = _interopRequireWildcard(require("../../shared_desktop_styles.css"));
var _MenuContainer = require("../../../../containers/MenuContainer");
var _AddressInput = require("../../../AddressInput");
var _RoomsCountSelector = require("../../../RoomsCountSelector");
var _AreaInput = require("../../../AreaInput");
var _FilterWithDropdownList = require("../../../packages/FilterWithDropdownList");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const FlatDesktop = props => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles['container']
  }, /*#__PURE__*/React.createElement(_MenuContainer.MenuContainer, null), /*#__PURE__*/React.createElement("form", {
    className: styles['form'],
    onSubmit: e => e.preventDefault()
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['filters']
  }, /*#__PURE__*/React.createElement("div", {
    className: (0, _clsx.default)(styles['filter'], styles['filter-estimation-target'])
  }, /*#__PURE__*/React.createElement(_FilterWithDropdownList.FilterWithDropdownList, (0, _extends2.default)({
    className: styles['filter-height']
  }, props.estimationTargetProps, {
    isFirstFilter: true,
    testId: "estimation_target"
  }))), /*#__PURE__*/React.createElement("div", {
    className: (0, _clsx.default)(styles['filter'], styles['filter-address'])
  }, /*#__PURE__*/React.createElement(_AddressInput.AddressInput, (0, _extends2.default)({
    className: styles['filter-height']
  }, props.addressProps))), /*#__PURE__*/React.createElement("div", {
    className: styles['filter']
  }, /*#__PURE__*/React.createElement(_RoomsCountSelector.RoomsCountSelector, (0, _extends2.default)({
    className: styles['filter-height']
  }, props.roomsCountSelectorProps))), /*#__PURE__*/React.createElement("div", {
    className: styles['filter']
  }, /*#__PURE__*/React.createElement(_AreaInput.AreaInput, (0, _extends2.default)({
    className: styles['filter-height']
  }, props.areaProps, {
    isLastFilter: true
  }))))));
};
exports.FlatDesktop = FlatDesktop;
FlatDesktop.displayName = 'FlatDesktop';